import { Initiative } from '../types/Initiative';
import { create } from 'zustand';
import { ShowMessageCalBack } from '../components';
import { fetchData } from '../axios/fetchData';
import { NavigateFunction } from 'react-router';

type InitiativesState = {
  initiatives: Initiative[];
  isLoading: boolean;
};

type InitiativesActions = {
  fetchInitiatives: (
    countryId: string,
    showMessage: ShowMessageCalBack,
    navigate: NavigateFunction,
  ) => void;
  modifyInitiative: (initiativeId: string, changes: any) => void;
  setIsLoading: (isLoading: boolean) => void;
};

export const useInitiativesStore = create<InitiativesState & InitiativesActions>()((set, get) => ({
  initiatives: [],
  isLoading: false,
  setIsLoading: (isLoading) => {
    return set({ isLoading });
  },
  fetchInitiatives: async (countryId, showMessage, navigate) => {
    get().setIsLoading(true);
    const result = await fetchData(
      {
        url: `${import.meta.env.VITE_APP_INITIATIVES}${countryId}`,
        params: {
          _format: 'json', // Added format=json to the request
        },
      },
      showMessage,
      navigate,
    );
    get().setIsLoading(false);
    return set({
      initiatives: (Object.values(result.data) as Initiative[]) || [],
    });
  },
  modifyInitiative: (id, changes) =>
    set((prevState) => ({
      initiatives: prevState.initiatives.map((i) => (i.id === id ? { ...i, ...changes } : i)),
    })),
}));
